import { FormContainerComponent } from 'src/features/generalForms/builder/types/Container';
import { RPDF } from 'src/features/report/react-pdf';

export const RootContainer: FormContainerComponent = ({ children }) => {
  return <RPDF.View>{children}</RPDF.View>;
};
